<template>
	<div class="mapper-item">
		<div v-if="localItem">Item: {{ localItem }}</div>
		<div v-else>
			<h2 class="med mt-4">Choose item type</h2>
			<div role="button" class="item_type my-2" v-for="item in items" :key="item" @click="localItem = item">
				<span class="pl-3 primary--text">{{ item }}</span>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getWidgetFieldData } from '@/store/modules/widgets/getters';
import { getConfigurationAndInterfaceIdByFieldUUID } from '@/store/modules/selectedWorkflow/modules/configurations/getters';

export default {
	name: 'MapperItemEditor',
	props: {
		widgetFieldUUID: { type: String },
		service: { type: Object },
	},
	components: {},
	computed: {
		...mapGetters([getWidgetFieldData.fullPath, getConfigurationAndInterfaceIdByFieldUUID.fullPath]),
		mapperData() {
			return this[getWidgetFieldData.fullPath](this.widgetFieldUUID)?.widgetField || {};
		},
		existingItem() {
			return this.mapperData?.metadata?.source?.field_item || '';
		},
		configurationAndInterfaceIdByFieldUUID() {
			return this[getConfigurationAndInterfaceIdByFieldUUID.fullPath](this.widgetFieldUUID);
		},
		interface() {
			return this.configurationAndInterfaceIdByFieldUUID.interface;
		},
		items() {
			return Object.keys(this.service?.param_mappings);
		},
		localItem: {
			get() {
				return this.existingItem;
			},
			async set(value) {
				if (value !== this.existingItem) {
					this.$emit('save-field-item', value);
				}
			},
		},
	},
};
</script>

<style lang="scss" scoped>
.mapper-name {
	.name-title {
		font-size: 18px;
		font-weight: 400;
	}
	.name-sub-title {
		font-size: 10px;
	}
	.name-block {
		font-size: 12px;
	}
}
</style>
